export default "__VITE_ASSET__Bb4Xp6Jk__"